import React from 'react';
import {Button} from 'antd';
import {GoogleOutlined} from '@ant-design/icons';

// One button per OIDC provider. Provider prop drives icon + label + href.
// Why centralized: the Continue-with-X look-and-feel is brand identity, and
// portal will render three of these (Google, Microsoft, Meta) on the login
// page. Editor doesn't render this directly today but may need it for the
// out-of-band re-auth flow.

const PROVIDER_META = {
    google: {label: 'Google', icon: <GoogleOutlined />, href: '/auth/google'},
    microsoft: {label: 'Microsoft', icon: null, href: '/auth/microsoft'},
    meta: {label: 'Meta', icon: null, href: '/auth/meta'},
};

function LoginButton({provider, disabled}) {
    const meta = PROVIDER_META[provider];
    if (!meta) {
        // Why fail loud: we'd rather break the login page than silently render
        // a no-op button labeled "Continue with X".
        throw new Error(`Unknown OIDC provider: ${provider}`);
    }
    return (
        <Button
            href={meta.href}
            icon={meta.icon}
            size="large"
            block
            disabled={disabled}
            style={{textAlign: 'left'}}
        >
            Continue with {meta.label}
        </Button>
    );
}

export default LoginButton;
